"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPOINTMENTS_UPCOMING_DAYS_AHEAD = exports.CALENDAR_SLOT_MS = exports.CALENDAR_SLOT_MINUTES = exports.CALENDAR_DAY_END_HOUR = exports.CALENDAR_DAY_START_HOUR = void 0;
exports.startOfLocalDay = startOfLocalDay;
exports.addDays = addDays;
exports.startOfLocalWeek = startOfLocalWeek;
exports.weekRange = weekRange;
exports.upcomingDaysRange = upcomingDaysRange;
exports.upcomingDayColumns = upcomingDayColumns;
exports.dayRange = dayRange;
exports.startOfLocalMonth = startOfLocalMonth;
exports.addMonths = addMonths;
exports.monthRange = monthRange;
exports.calendarRangeForView = calendarRangeForView;
exports.shiftCalendarAnchor = shiftCalendarAnchor;
exports.monthGridDays = monthGridDays;
exports.formatPeriodLabel = formatPeriodLabel;
exports.calendarGridStart = calendarGridStart;
exports.calendarGridEnd = calendarGridEnd;
exports.slotCountForDay = slotCountForDay;
exports.snapToSlot = snapToSlot;
exports.moveAppointmentToLocalDay = moveAppointmentToLocalDay;
exports.moveAppointmentInterval = moveAppointmentInterval;
exports.yToSlotDate = yToSlotDate;
exports.appointmentTopPx = appointmentTopPx;
exports.appointmentHeightPx = appointmentHeightPx;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatDayMonth = formatDayMonth;
exports.formatTimeRange = formatTimeRange;
/** Ώρα έναρξης ημερολογίου (τοπική) */
exports.CALENDAR_DAY_START_HOUR = 7;
/** Ώρα λήξης ημερολογίου (τοπική, αποκλειστική) */
exports.CALENDAR_DAY_END_HOUR = 21;
/** Βήμα πλέγματος / snap DnD (λεπτά) */
exports.CALENDAR_SLOT_MINUTES = 30;
exports.CALENDAR_SLOT_MS = exports.CALENDAR_SLOT_MINUTES * 60 * 1000;
function startOfLocalDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}
function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}
/** Δευτέρα της εβδομάδας (τοπική) */
function startOfLocalWeek(date) {
    const d = startOfLocalDay(date);
    const day = d.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    return d;
}
function weekRange(anchor) {
    const from = startOfLocalWeek(anchor);
    const to = addDays(from, 7);
    return { from, to };
}
/** Ημέρες μπροστά από την ημέρα anchor (σήμερα + N = N+1 ημέρες συνολικά). */
exports.APPOINTMENTS_UPCOMING_DAYS_AHEAD = 7;
function upcomingDaysRange(anchor, daysAhead = exports.APPOINTMENTS_UPCOMING_DAYS_AHEAD) {
    const from = startOfLocalDay(anchor);
    const to = addDays(from, daysAhead + 1);
    return { from, to };
}
function upcomingDayColumns(anchor, daysAhead = exports.APPOINTMENTS_UPCOMING_DAYS_AHEAD) {
    const from = startOfLocalDay(anchor);
    return Array.from({ length: daysAhead + 1 }, (_, i) => addDays(from, i));
}
function dayRange(anchor) {
    const from = startOfLocalDay(anchor);
    return { from, to: addDays(from, 1) };
}
function startOfLocalMonth(date) {
    const d = startOfLocalDay(date);
    d.setDate(1);
    return d;
}
function addMonths(date, months) {
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    return d;
}
function monthRange(anchor) {
    const from = startOfLocalMonth(anchor);
    const to = addMonths(from, 1);
    return { from, to };
}
function calendarRangeForView(anchor, view) {
    if (view === 'day')
        return dayRange(anchor);
    if (view === 'month')
        return monthRange(anchor);
    if (view === 'upcoming')
        return upcomingDaysRange(anchor);
    return weekRange(anchor);
}
function shiftCalendarAnchor(anchor, view, delta) {
    if (view === 'day')
        return addDays(anchor, delta);
    if (view === 'month')
        return addMonths(anchor, delta);
    if (view === 'upcoming') {
        return addDays(startOfLocalDay(anchor), delta * (exports.APPOINTMENTS_UPCOMING_DAYS_AHEAD + 1));
    }
    return addDays(startOfLocalWeek(anchor), delta * 7);
}
/** 6 εβδομάδες × 7 ημέρες για πλέγμα μήνα (Δευτέρα πρώτη) */
function monthGridDays(anchor) {
    const monthStart = startOfLocalMonth(anchor);
    const gridStart = startOfLocalWeek(monthStart);
    return Array.from({ length: 42 }, (_, i) => addDays(gridStart, i));
}
function formatPeriodLabel(anchor, view, locale = 'el-GR') {
    if (view === 'day') {
        return anchor.toLocaleDateString(locale, {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    }
    if (view === 'month') {
        return anchor.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
    }
    if (view === 'upcoming') {
        const { from, to } = upcomingDaysRange(anchor);
        const end = addDays(to, -1);
        const today = startOfLocalDay(new Date());
        if (from.getTime() === today.getTime()) {
            return `Σήμερα – ${formatDayMonth(end, locale)}`;
        }
        return `${formatDayMonth(from, locale)} – ${formatDayMonth(end, locale)}`;
    }
    const { from, to } = weekRange(anchor);
    const end = addDays(to, -1);
    return `${formatDayMonth(from, locale)} – ${formatDayMonth(end, locale)}`;
}
function calendarGridStart(anchor) {
    const d = startOfLocalDay(anchor);
    d.setHours(exports.CALENDAR_DAY_START_HOUR, 0, 0, 0);
    return d;
}
function calendarGridEnd(anchor) {
    const d = startOfLocalDay(anchor);
    d.setHours(exports.CALENDAR_DAY_END_HOUR, 0, 0, 0);
    return d;
}
function slotCountForDay() {
    return ((exports.CALENDAR_DAY_END_HOUR - exports.CALENDAR_DAY_START_HOUR) * 60) / exports.CALENDAR_SLOT_MINUTES;
}
function snapToSlot(date) {
    const d = new Date(date);
    const minutes = d.getMinutes();
    const snapped = Math.round(minutes / exports.CALENDAR_SLOT_MINUTES) * exports.CALENDAR_SLOT_MINUTES;
    d.setMinutes(snapped, 0, 0);
    return d;
}
/** Μετακίνηση σε άλλη ημέρα (π.χ. month view), διατηρώντας ώρα έναρξης. */
function moveAppointmentToLocalDay(startAt, endAt, targetDay) {
    const start = new Date(startAt);
    const nextStart = startOfLocalDay(targetDay);
    nextStart.setHours(start.getHours(), start.getMinutes(), 0, 0);
    return moveAppointmentInterval(startAt, endAt, nextStart);
}
function moveAppointmentInterval(startAt, endAt, nextStart) {
    const start = new Date(startAt);
    const end = new Date(endAt);
    const durationMs = Math.max(end.getTime() - start.getTime(), exports.CALENDAR_SLOT_MS);
    const snappedStart = snapToSlot(nextStart);
    return {
        startAt: snappedStart,
        endAt: new Date(snappedStart.getTime() + durationMs),
    };
}
function yToSlotDate(day, yPx, slotHeightPx) {
    const slotIndex = Math.max(0, Math.min(slotCountForDay() - 1, Math.round(yPx / slotHeightPx)));
    const d = calendarGridStart(day);
    d.setMinutes(d.getMinutes() + slotIndex * exports.CALENDAR_SLOT_MINUTES);
    return snapToSlot(d);
}
function appointmentTopPx(startAt, slotHeightPx) {
    const start = new Date(startAt);
    const gridStart = calendarGridStart(start);
    const diffMinutes = (start.getTime() - gridStart.getTime()) / 60000;
    const slotIndex = Math.max(0, diffMinutes / exports.CALENDAR_SLOT_MINUTES);
    return slotIndex * slotHeightPx;
}
function appointmentHeightPx(startAt, endAt, slotHeightPx) {
    const start = new Date(startAt);
    const end = new Date(endAt);
    const minutes = Math.max(exports.CALENDAR_SLOT_MINUTES, (end.getTime() - start.getTime()) / 60000);
    return (minutes / exports.CALENDAR_SLOT_MINUTES) * slotHeightPx;
}
function formatWeekdayShort(date, locale = 'el-GR') {
    return date.toLocaleDateString(locale, { weekday: 'short' });
}
function formatDayMonth(date, locale = 'el-GR') {
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
}
function formatTimeRange(startAt, endAt, locale = 'el-GR') {
    const start = new Date(startAt);
    const end = new Date(endAt);
    const opts = { hour: '2-digit', minute: '2-digit' };
    return `${start.toLocaleTimeString(locale, opts)} – ${end.toLocaleTimeString(locale, opts)}`;
}
